'use strict';

function scrollingFunction(g) {
  function scrollingToggleClass() {
    var $topScroll = $(window).scrollTop();

    if ($topScroll > 0) {
      $('html').addClass('scrolling');
    } else {
      $('html').removeClass('scrolling');
    }
  }

  function init() {
    scrollingToggleClass();
    $(window).on('resize', scrollingToggleClass);
    $(window).on('scroll', scrollingToggleClass);
  }

  init();
}
